import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error: unknown;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('App crashed:', error);
    const stack =
      typeof info === 'object' && info != null && 'componentStack' in info
        ? (info as any).componentStack
        : null;
    console.error('Component stack:', stack ?? info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
          <div className="max-w-xl w-full space-y-3">
            <div className="text-2xl font-semibold">Something went wrong</div>
            <div className="text-sm text-muted-foreground">
              The app crashed in this browser. Open DevTools Console to see the component stack.
            </div>
            <pre className="text-xs overflow-auto p-3 rounded-md bg-muted/40 border border-border">
              {String((this.state.error as any)?.message ?? this.state.error ?? 'Unknown error')}
            </pre>
            <button
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-primary-foreground"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
